import React from 'react';
import './ProjectsPage.css';
import logo from "../assets/bg-remover-logo.png"
function ProjectsPage() {
  return (
    <div className="projects-page">
      {/* Hero Section */}
      <section className="projects-hero">
        <div className="container">
          <div className="hero-content">
            <h1 className="hero-title">Our Projects</h1>
            <p className="hero-description">
              Showcasing our successful sports infrastructure projects across Rajasthan and beyond
            </p>
          </div>
        </div>
      </section>

      {/* No Projects Available */}
      <section className="no-projects">
        <div className="container">
          <div className="no-projects-content">
            <div className="no-projects-icon">📋</div>
            {/* <h2 className="no-projects-title">No Projects Available</h2> */}
            <p className="no-projects-description">
              We are currently working on exciting new projects. Check back soon to see our latest work and achievements.
            </p>
            <div className="no-projects-placeholder">
              <div className="placeholder-card">
                <div className="placeholder-image">
                </div>
                <div className="placeholder-text">

                  <div className="placeholder-line"></div>
                  <div className="placeholder-line short"></div>
                </div>
              </div>
              <div className="placeholder-card">
                <div className="placeholder-image"></div>
                <div className="placeholder-text">
                  <div className="placeholder-line"></div>
                  <div className="placeholder-line short"></div>
                </div>
              </div>
              <div className="placeholder-card">
                <div className="placeholder-image"></div>
                <div className="placeholder-text">
                  <div className="placeholder-line"></div>
                  <div className="placeholder-line short"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Hours & Complete Projects Section */}
      <section className="hours-projects-section">
        <div className="container">
          <h2 className="section-title">Our Achievements</h2>
          <div className="achievements-grid">
            <div className="achievement-card">
              <div className="achievement-icon">⏰</div>
              <div className="achievement-content">
                <h3 className="achievement-title">Working Hours</h3>
                <div className="achievement-stats">
                  <div className="stat-item">
                    <span className="stat-number">50,000+</span>
                    <span className="stat-label">Hours Completed</span>
                  </div>
                  <div className="stat-item">
                    <span className="stat-number">24/7</span>
                    <span className="stat-label">Support Available</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="achievement-card">
              <div className="achievement-icon">🏆</div>
              <div className="achievement-content">
                <h3 className="achievement-title">Complete Projects</h3>
                <div className="achievement-stats">
                  <div className="stat-item">
                    <span className="stat-number">500+</span>
                    <span className="stat-label">Projects Delivered</span>
                  </div>
                  <div className="stat-item">
                    <span className="stat-number">100%</span>
                    <span className="stat-label">Success Rate</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="achievement-card">
              <div className="achievement-icon">🏟️</div>
              <div className="achievement-content">
                <h3 className="achievement-title">Sports Facilities</h3>
                <div className="achievement-stats">
                  <div className="stat-item">
                    <span className="stat-number">50+</span>
                    <span className="stat-label">Sports Types</span>
                  </div>
                  <div className="stat-item">
                    <span className="stat-number">20+</span>
                    <span className="stat-label">Years Experience</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="achievement-card">
              <div className="achievement-icon">👥</div>
              <div className="achievement-content">
                <h3 className="achievement-title">Client Satisfaction</h3>
                <div className="achievement-stats">
                  <div className="stat-item">
                    <span className="stat-number">1000+</span>
                    <span className="stat-label">Happy Clients</span>
                  </div>
                  <div className="stat-item">
                    <span className="stat-number">5★</span>
                    <span className="stat-label">Average Rating</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      {/* Footer */}
      <footer className="footer">
        <div className="footer-background"></div>
        <div className="container">
          <div className="footer-content">
            <div className="footer-column">
              <h3 className="footer-title">About Us</h3>
              <p className="footer-text">
                We are committed to excellence in sports training and community building.
                Our comprehensive programs help athletes develop both physically and mentally.
              </p>
            </div>
            <div className="footer-column">
              <h3 className="footer-title">Latest Posts</h3>
              <div className="footer-post">
                <div className="post-date">
                  <span className="day">15</span>
                  <span className="month">Fri</span>
                </div>
                <div className="post-content">
                  <h4 className="post-title">New Training Program Launched</h4>
                  <p className="post-excerpt">Advanced coaching techniques for professional athletes</p>
                </div>
              </div>
              <div className="footer-post">
                <div className="post-date">
                  <span className="day">04</span>
                  <span className="month">Fri</span>
                </div>
                <div className="post-content">
                  <h4 className="post-title">Championship Results Announced</h4>
                  <p className="post-excerpt">Outstanding performances in the latest tournament</p>
                </div>
              </div>
              <button className="view-more">View More...</button>
            </div>
            <div className="footer-column">
              <h3 className="footer-title">Quick Links</h3>
              <ul className="footer-links">
                <li><a href="/" className="footer-link">HOME</a></li>
                <li><a href="#" className="footer-link">ABOUT OUR WEBSITE</a></li>
                <li><a href="#" className="footer-link">SHOP</a></li>
                <li><a href="#" className="footer-link">GALLERY</a></li>
                <li><a href="/contact" className="footer-link">CONTACT</a></li>
              </ul>
            </div>
            <div className="footer-column">
              <h3 className="footer-title">Contact Details</h3>
              <div className="contact-info">
                <div className="contact-item">📍 36/B Lane no.5 dharm park shyam nagar-2 Rajasthan/Jaipur - 302019</div>
                <div className="contact-item">📞 +91-9414050348</div>
                <div className="contact-item">✉️ askmesportsalliance@gmail.com</div>
                <div className="contact-item">🌐 www.askmesportsalliance.com</div>
                <div className="contact-item">🕐 7AM - 8PM</div>
              </div>
            </div>
          </div>
          <div className="footer-logo">
            <img src={logo} alt="Sports Alliance Logo" className="footer-logo-icon" />
            <span className="footer-logo-text">ASK ME SPORTS ALLIANCE</span>
          </div>
          <div className="footer-social">
            <span className="social-icon">f</span>
            <span className="social-icon">t</span>
            <span className="social-icon">in</span>
            <span className="social-icon">G+</span>
          </div>
          <div className="footer-copyright">
            Copyright © 2023 ASK ME SPORTS ALLIANCE. Building Future, Shaping Champions.
          </div>
        </div>
      </footer>
    </div>
  );
}

export default ProjectsPage;